import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import Link from "next/link"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import Consultants from "/.sourceflow/consultants.json";
import urlSlug from 'url-slug'
import LinkedIn from "/public/site-assets/svg/linkedin.svg";
import Envelope from "/public/site-assets/svg/mail.svg";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SocialShare from "../../components/Shared/SF_SocialShareCard_001";
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import HubSpotForm from '../../components/HubspotForm';

export default function NewBlogDetails({
    className,
    pathPrefix,
    page,
    related_news,
    page_prefix,
    share_heading = " Share Insight",
    locale,
    formId,
    successPageUrl = `${locale == "us" ? "/us/submission-success" : "/submission-success"}`,
}) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    return (
        <section className={clsx(className, styles.root)}>
            <Container>
                <Row>
                    <Col lg={9} className={"left"}>
                        <div className="post-content" dangerouslySetInnerHTML={{ __html: page?.content }} />
                        {page.guides_reports_key?.length >= 1 && (
                            <div className='mt-4'>
                                <h4 className='mb-3'>
                                    <SourceFlowText global={global} path={`${pathPrefix}.keys.heading`}>
                                        Key Salary & Compensation insights in the {locale == "us" ? "US" : "UK"}
                                    </SourceFlowText>
                                </h4>
                                <div className='d-flex case-studies-key flex-wrap mb-5'>
                                    {page.guides_reports_key.map((post, index) =>
                                        <Card key={index}>
                                            <div className='post-title'>{post.title}</div>
                                            <div className='post-description'>{post.content}</div>
                                        </Card>
                                    )}
                                </div>
                            </div>
                        )}
                        {formId ?
                            <div id={`download-form`}>
                                <SourceFlowForm
                                    formId={formId}
                                    onSubmitDone={() => {
                                        // console.log("PDF URL:", page?.form_attachment);
                                        if (page?.form_attachment) {
                                            // Open the form attachment link in a new tab
                                            window.open(page.form_attachment, "_blank");
                                        } else {
                                            // Redirect to the success page if no attachment is available
                                            window.location.href = successPageUrl;
                                        }
                                    }}
                                />
                            </div>
                        : page?.hubspot_id ? (
                            <HubSpotForm form_id={page.hubspot_id} />
                        ) : null}
                    </Col>
                    <Col lg={3} className="position-relative mt-4 mt-lg-0">
                        <div className='sticky-column'>
                            {page.tag.includes("Guides & Reports") ? "" :
                                page.author && (
                                    <div>
                                        {Consultants?.category_values?.map((post, index) => {
                                            if (post?.url_slug === urlSlug(page?.author)) {
                                                return (
                                                    <>
                                                        <h5 className='heading fw-bold mb-1'>
                                                            <SourceFlowText global={global} path={`${pathPrefix}.author.heading`} type="text">
                                                                Author
                                                            </SourceFlowText>
                                                       
                                                        </h5>
                                                        <div key={index} className='mb-4'>
                                                            {post.title.en && (
                                                                <div className='post-author fw-bold'>{post.title.en}</div>
                                                            )}

                                                            <div className='d-flex post-socials-wrapper gap-2'>
                                                                {post?.linkedin.en && (
                                                                    <a href={`${post.linkedin.en}`} target="_blank" className='post-socials d-flex justify-content-center align-items-center' rel="noopener noreferrer">
                                                                        <LinkedIn />
                                                                    </a>
                                                                )}
                                                                {post?.email.en && (
                                                                    <a href={`mailto:${post.email.en}`} target="_blank" className='post-socials  d-flex justify-content-center align-items-center'>
                                                                        <Envelope />
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <hr />
                                                    </>
                                                )
                                            }
                                        })}
                                    </div>
                                )
                            }
                           {page.author && (
                            <div className="mb-2 fw-bold"><span>Author: </span>{page.author}</div>
                           )}
                            <div>
                                {page.date && (
                                    <div className="mb-2"><span>Published Date: </span>{formatDate(page.date)}</div>
                                )}
                                <h5 className='heading fw-bold mb-2'>
                                    <SourceFlowText global={global} path={`${pathPrefix}.share_insight.heading`} type="text">
                                        {share_heading}
                                    </SourceFlowText>
                                </h5>
                                <SocialShare
                                    pageTitle={`${page.title}`}
                                    pageUrl={`https://www.lorienglobal.com/${locale == "us" ? "us/" : ""}${page_prefix}/${page.url_slug}`}
                                    blogPage={true}
                                    className={`blog-style`}
                                />
                            </div>
                            {page.tag.includes("Guides & Reports") ? "" :
                                related_news.length >= 1 && (
                                    <div>
                                        <hr />
                                        <h5 className='heading fw-bold mb-4'>
                                            <SourceFlowText global={global} path={`${pathPrefix}.related_insights.heading`} type="text">
                                                Related insights
                                            </SourceFlowText>
                                        </h5>
                                        <div className='d-flex gap-4 flex-wrap'>
                                            {related_news.map((post, index) => (
                                                <Card key={index} className={`w-100 d-block`}>
                                                    <a href={`${locale == "us" ? "/us" : ""}/insights/${post.url_slug}`} className='d-block'>
                                                        <div>
                                                            <SourceFlowImage
                                                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                                size="400x250"
                                                                alt={post?.title}
                                                                className="card-img"
                                                                width="100%"
                                                                height="100%"
                                                            />
                                                            {post.tag.length >= 1 && (
                                                                <div className='card-tags flex-wrap'>
                                                                    {post.tag.map((post, index) => (
                                                                        <span key={index}>{post}</span>
                                                                    ))}
                                                                </div>
                                                            )}

                                                        </div>
                                                        <div className='px-2'>
                                                            <div className='card-title mt-3'>
                                                                {post.title}
                                                            </div>
                                                            <div className='card-short-paragraph'>
                                                                <div dangerouslySetInnerHTML={{ __html: post.short_description }} />
                                                            </div>
                                                            <div className='mt-4 card-read-more'>
                                                                Read More
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Card>
                                            ))}
                                        </div>
                                    </div>
                                )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section >
    )
}



NewBlogDetails.defaultProps = {
    pathPrefix: "",
    className: "py-5",
};

NewBlogDetails.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};